<script setup>
import { VNavigationDrawer } from 'vuetify/lib/components/index.mjs'
import ConfirmComponent from '@/components/common/Confirm.vue'
import BoardCommentReport from './BoardCommentReport.vue'
import IconHeaderBack from '../svg/IconHeaderBack.vue'
import { useDeviceDetect } from '@/composables/useDeviceDetect'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  targetComment: {
    type: Object,
  },
})
const emit = defineEmits(['update:modelValue', 'close'])

const open = computed({
  get: () => props.modelValue,
  set: (v) => emit('update:modelValue', v),
})

const dialogTitle = ref('')
const dialogTitle2 = ref('')
const dialogText = ref('')
const dialogNextUrl = ref('')
const dialogConfirm = ref(null)
const warningTxt = ref('')

const currentUserId = computed(() => sessionStorage.getItem('authUserId') ?? '')
const { isMobile } = useDeviceDetect()

const params = {
  // 추후 신고 API 용 파라미터로
}

/** 신고 접수 */
const submitReport = () => {
  // 추후 API
  emit('close')
}

/** 댓글 리스트로 돌아가기 */
const backToList = () => {
  emit('close')
}

onMounted(() => {})

/** 컨펌창 용 함수 */
const showDialogConfirm = (title, title2 = '', text = '', onConfirm = () => {}, warning) => {
  dialogTitle.value = title
  dialogTitle2.value = title2
  dialogText.value = text
  dialogNextUrl.value = onConfirm
  warningTxt.value = warning
  dialogConfirm.value.openConfirmDialog()
}
</script>
<template>
  <Teleport to="body">
    <!-- Mobile: bottom drawer -->
    <template v-if="isMobile">
      <VNavigationDrawer
        v-model="open"
        width="100%"
        :height="'100dvh'"
        location="bottom"
        temporary
        :scrim="true"
        touchless
        class="board-comment-drawer"
      >
        <div class="comment-drawer__wrapper">
          <div class="comment-drawer__header">
            <div class="comment-drawer__h-box">
              <button class="btn-back" @click="backToList">
                <IconHeaderBack />
              </button>
              <span>신고하기</span>
            </div>
          </div>
          <div class="comment-drawer__list">
            <BoardCommentReport @submitReport="submitReport" @backToList="backToList" />
          </div>
        </div>
      </VNavigationDrawer>
    </template>

    <!-- Desktop: centered modal -->
    <template v-else>
      <div v-if="open" class="report-modal__backdrop" @click.self="backToList">
        <div class="report-modal__container" role="dialog" aria-modal="true">
          <div class="report-modal__header">
            <span>신고하기</span>
            <button class="report-modal__close" @click="backToList" aria-label="닫기" />
          </div>
          <div class="report-modal__body">
            <BoardCommentReport @submitReport="submitReport" @backToList="backToList" />
          </div>
        </div>
      </div>
    </template>
  </Teleport>

  <ConfirmComponent
    ref="dialogConfirm"
    :title="dialogTitle"
    :title2="dialogTitle2"
    :text="dialogText"
    :nextUrl="dialogNextUrl"
    :warning="warningTxt"
  />
</template>
<style scoped>
.report-modal__backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}
.report-modal__container {
  width: 560px;
  max-width: calc(100vw - 40px);
  max-height: calc(100vh - 80px);
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.report-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid var(--Gray-300, #ebebeb);
}
.report-modal__close {
  width: 24px;
  height: 24px;
  background: url('/src/assets/images/icon-close.svg') center center no-repeat;
  background-size: 16px 16px;
  border: none;
  cursor: pointer;
}
.report-modal__body {
  padding: 20px;
  overflow: auto;
}
</style>
